import { render, staticRenderFns } from "./__PageVisitsTable.vue?vue&type=template&id=23f9fd86&"
import script from "./__PageVisitsTable.vue?vue&type=script&lang=js&"
export * from "./__PageVisitsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports